import api from './client'

// Промокоды (10.2026). /promo/check — только расчёт, ничего не резервирует:
// резерв делает сам платёж (поле promo_code в /payments/create и /topup),
// сервер там всё пересчитывает. /promo/activate — код на фиксированные
// бонусные токены: начисляет сразу, без покупки.

export type PromoPurchaseKind = 'subscription' | 'tariff_one_time' | 'topup' | 'package'

export interface PromoPurchase {
	purchase_kind: PromoPurchaseKind
	tariff_id?: string
	amount?: number
	package_id?: string
}

export interface PromoQuote {
	ok: true
	code: string
	name: string
	kind: 'discount' | 'bonus'
	value_type: 'fixed' | 'percent'
	value: number
	purchase_kind: PromoPurchaseKind
	price_before: number
	discount_rub: number
	price_after: number
	base_credits: number
	bonus_credits: number
	credits_total: number
	/** «Скидка 20 %», «+20 % токенов к покупке» */
	summary: string
}

/** Отказ приходит с HTTP 200: message — готовый текст для юзера. */
export interface PromoFailure {
	ok: false
	reason: string
	message: string
	/** reason purchase_only: на какие покупки действует код */
	purchase_kinds?: PromoPurchaseKind[]
}

export interface PromoActivation {
	ok: true
	code: string
	credited: number
	balance: number
	summary: string
}

/** Как на бэке (normalize_code): без пробелов, заглавными. */
export function normalizePromo(raw: string): string {
	return (raw || '').replace(/\s+/g, '').toUpperCase()
}

/** Показывать ли промокоды этому юзеру (настройка доступа в админке). */
export function getPromoAvailable(): Promise<{ available: boolean }> {
	return api.request<{ available: boolean }>('/api/v1/promo/available')
}

export function checkPromo(code: string, purchase: PromoPurchase): Promise<PromoQuote | PromoFailure> {
	return api.request<PromoQuote | PromoFailure>('/api/v1/promo/check', {
		method: 'POST',
		body: { code: normalizePromo(code), ...purchase },
	})
}

export function activatePromo(code: string): Promise<PromoActivation | PromoFailure> {
	return api.request<PromoActivation | PromoFailure>('/api/v1/promo/activate', {
		method: 'POST',
		body: { code: normalizePromo(code) },
	})
}

// ── Код из ссылки ?promo=CODE ─────────────────────────────────────────
// Кладёт App (как ?ref= → referral_code), читают поля промокода: тарифы,
// докупка, активация в кабинете. Снимается после платежа с этим кодом или
// активации. localStorage может бросить (приватный режим) — не критично.
const STORAGE_KEY = 'promo_code'
const CODE_RE = /^[A-ZА-ЯЁ0-9_-]{3,50}$/

export function getStoredPromo(): string {
	try {
		return localStorage.getItem(STORAGE_KEY) || ''
	} catch {
		return ''
	}
}

export function storePromo(raw: string): void {
	const code = normalizePromo(raw)
	if (!CODE_RE.test(code)) return
	try {
		localStorage.setItem(STORAGE_KEY, code)
	} catch { /* приватный режим */ }
}

/** Снимает сохранённый код; с аргументом — только если сохранён именно он. */
export function clearStoredPromo(code?: string): void {
	try {
		if (code && normalizePromo(localStorage.getItem(STORAGE_KEY) || '') !== normalizePromo(code)) return
		localStorage.removeItem(STORAGE_KEY)
	} catch { /* приватный режим */ }
}
